<template>
    <div class="clearfix padding-right-20">
        <Form ref="submitForm" :rules="formRule" v-model="formData" :labelWidth="120">
            <FormItem :label="$t('erp.b2c.latest_time', { defaultValue: '最晚发货时间' })" prop="latestShipDate">
                <DatePicker style="width: 100%;" v-model="formData.latestShipDate" :options="disableDate" format="yyyy-MM-dd" type="date"></DatePicker>
            </FormItem>
            <FormItem :label="$t('global.common.notes', { defaultValue: '备注' })" prop="remark">
                <Input v-model="formData.remark" type="textarea" />
            </FormItem>
        </Form>
        <div class="tip-font color-error margin-left-30" v-html="$t('erp.distribution.lastest_ship_date_tip', { defaultValue: '<p>注意：</p><p>1.只有待人工审核状态和已审核状态可以修改；</p><p>2.修改最晚发货时间后，系统不会重新计算，推送仓库以手动修改后的时间为准。建议跟平台确认后再修改，以免影响发货时效！</p>' })">
        </div>
        <div class="pull-right button-container">
            <Button class="margin-right-15" type="primary" @click="submit">{{$t('erp.distribution.confirm_submit', { defaultValue: '提交' })}}</Button>
            <Button type="default" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>
<script>
import { HttpChangeLastestTime } from "@/service/boss/distribution";
import moment from 'moment';
export default {
    props: ['activeids'],
    data () {
        return {
            formData: {},
            loading: false,
            disableDate: {
                disabledDate (date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            }
        }
    },
    computed: {
        formRule () {
            return {
                latestShipDate: [{
                    required: true,
                    trigger: 'change',
                    type: 'string',
                    message: this.$t('global.common.required', { defaultValue: '该信息不能为空,请填写' })
                }]
            }
        },
    },
    methods: {
        async submit () {
            if (!this.formData.latestShipDate) return this.$VMessage.warning(this.$t('global.common.fill_required', { defaultValue: '请填写必填项' }));
            this.loading = true;
            await HttpChangeLastestTime({
                deliverOrderIds: this.activeids,
                latestShipDate: moment(this.formData.latestShipDate).format('YYYY-MM-DD'),
                remark: this.formData.remark
            }).then(res => {
                this.$VMessage.success(res.message);
                this.cancel();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(() => {
                this.loading = false;
            });
        },
        cancel () {
            this.$emit('on-close');
        }
    }
}
</script>